export function stringIsNothing(str: string | null | undefined): boolean {
  return str === null || str === '' || str === undefined;
}

export function isSameText(a: string, b: string): boolean {
  return a.toLowerCase() === b.toLowerCase();
}
export function isAnyTextSame(text: string, ...values: string[]): boolean {
  return values.some((v) => isSameText(text, v));
}
export function sameAsAll(text: string, ...values: string[]): boolean {
  return values.every((v) => isSameText(text, v));
}
